export const VISA_LETTER = 'visaLetter';
export const PRESS_RELEASE = 'pressRelease';
